import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from "../../components/Loader/Loader";
import Avatar from "../../components/Avatar/Avatar";
import DropZone from "../../components/Dashboard/DropZone";

import { doRemoveProfilePicture } from "../../actions/manageUserProfilePicture";
import messages from "../../locale/jsonMessages";

import cs from '../../components/commonStyle.css';

class ProfileUpload extends React.Component {

    render() {
        const { picture, userId, profilePhotoLoading, doRemoveProfilePicture, isAdmin } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <Loader
                    show={profilePhotoLoading}
                    type={"page"}
                >
                    <Avatar
                        height={150}
                        width={150}
                        className={cs.profileAvatarLink}
                        source={picture}
                    />
                    {picture && <DropZone
                        guestPicture={picture}
                        isEditIcon
                        userId={userId}
                        isAdmin={isAdmin}
                    />}
                </Loader>
                {
                    !picture && <DropZone
                        guestPicture={picture}
                        defaultMessage={formatMessage(messages.updatePhotoLabel)}
                        userId={userId}
                        isAdmin={isAdmin}
                    />}
                {
                    picture && <div className={cx(cs.textAlignCenter, cs.spaceTop3, cs.spaceBottom11)}>
                        <a onClick={() => doRemoveProfilePicture(picture, userId, isAdmin)} className={cx(cs.commonContentText, cs.fontWeightMedium, cs.siteLinkColor, cs.textDecorationNone, cs.commonLinkBorderBottom, cs.textAlignCenter, cs.curserPointer)} >
                            <FormattedMessage {...messages.removeProfilePhoto} />
                        </a>
                    </div>
                }
            </div>
        )
    }
}

const mapState = (state) => ({
    profilePhotoLoading: state?.account?.profilePhotoLoading
})
const mapDispatch = {
    doRemoveProfilePicture
}

export default compose(injectIntl, withStyles(cs), connect(mapState, mapDispatch))(ProfileUpload);